import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useContext } from "react";
import contextBabylon from "../../../../../../../../context/index.js";
import { formatPriceWithCurrency } from "../../../../../../../../helpers/currency/index.js";
import * as S from "./styled.js";
const ProductDesktop = ({ product , literals , hasBanner =false  })=>{
    const { Currency , Language  } = useContext(contextBabylon);
    const resize = {
        width: 90,
        height: 90,
        quality: 85,
        operation: 'resize'
    };
    return /*#__PURE__*/ _jsxs(S.ProductContainer, {
        "data-testid": "ProductDesktop",
        $hasBanner: hasBanner,
        href: product?.buttonUrl,
        children: [
            product?.imageSrc && /*#__PURE__*/ _jsx(S.ProductImage, {
                resize: resize,
                src: product.imageSrc,
                alt: product?.imageAlt,
                title: product?.title,
                alternative: product?.imageAlternative
            }),
            /*#__PURE__*/ _jsxs(S.ProductMain, {
                children: [
                    product?.title && /*#__PURE__*/ _jsx(S.ProductTitle, {
                        tag: "h3",
                        content: product.title
                    }),
                    Children.toArray(product?.descriptions?.map((desc)=>/*#__PURE__*/ _jsx(S.ProductDesc, {
                            content: desc
                        }))),
                    product?.info && /*#__PURE__*/ _jsx(S.ProductInfo, {
                        content: product?.info
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(S.ProductAside, {
                children: [
                    product?.price && /*#__PURE__*/ _jsx(S.ProductPrice, {
                        children: formatPriceWithCurrency(product.price, Currency, Language)
                    }),
                    /*#__PURE__*/ _jsx(S.ProductPerPerson, {
                        children: literals?.pricePerPerson
                    }),
                    /*#__PURE__*/ _jsx(S.ProductLink, {
                        children: literals?.linkText
                    })
                ]
            })
        ]
    });
};
export default ProductDesktop;

//# sourceMappingURL=index.js.map